export default __webpack_public_path__ + "assets/fonts/Nunito-Bold-ed08c2ea.woff";